import { ref, computed } from 'vue';

// Tracks several concurrent requests: `loading` stays true until all of them finish.
export function useLoading() {
    const pending = ref(0);
    const loading = computed(() => pending.value > 0);

    const track = (promise) => {
        pending.value++;
        return promise.finally(() => {
            pending.value--;
        });
    };

    return { loading, track };
}
